module.exports = __webpack_public_path__ + "img/logo_full.82053faa.png";